import { getShouldHideSegments } from "app/components/widget/widget-config/metrics/segments/utils";
import AffiliateMarketingOptimization from "./templates/AffiliateMarketingOptimization";
import CompetitiveOverview from "./templates/CompetitiveOverview";
import WebsiteAudienceAnalysis from "./templates/WebsiteAudienceAnalysis";
import MarketAnalysisDashboard from "./templates/MarketAnalysisDashboard";
import DailyCompetitiveOverview from "./templates/DailyCompetitiveOverview";
import SocialMediaTrafficMonitoring from "./templates/SocialMediaTrafficMonitoring";
import Benchmark from "./templates/Benchmark";
import Evaluation from "./templates/Evaluation";
import SegmentAnalysisGroup from "./templates/SegmentAnalysisGroup";
import SegmentAnalysis from "./templates/SegmentAnalysis";
import SearchTrafficOverview from "./templates/SearchTrafficOverview";
import MarketShare from "./templates/MarketShare";

export default {
    getDashboardTemplates: () => {
        const templates = [
            MarketShare,
            SearchTrafficOverview(),
            DailyCompetitiveOverview,
            CompetitiveOverview,
            Benchmark,
            MarketAnalysisDashboard,
            WebsiteAudienceAnalysis,
            AffiliateMarketingOptimization,
            SocialMediaTrafficMonitoring,
            Evaluation,
        ];

        const shouldHideSegments = getShouldHideSegments();

        if (!shouldHideSegments) {
            templates.unshift(SegmentAnalysisGroup);
            templates.unshift(SegmentAnalysis);
        }

        return Promise.resolve(templates);
    },
};
